type TAnchor =
  | 'AccountDetails'
  | 'PasswordManagement'
  | 'Privacy'
  | 'SavedAddresses'
  | 'SavedCards';

export type IMenuItem = {
  menuLabel: string;
  scrollPosition: number;
  anchor: TAnchor;
  isActive?: boolean;
};
export type IconType =
  | 'AccountCircle'
  | 'amex'
  | 'ArrowDropDown'
  | 'ArrowDropUp'
  | 'Assignment'
  | 'BackToMag'
  | 'BookMark'
  | 'CalendarToday'
  | 'ChevronDown'
  | 'ChevronLeft'
  | 'ChevronRight'
  | 'ChevronUp'
  | 'ChromeReaderMode'
  | 'Close'
  | 'CropPortrait'
  | 'DebitCard'
  | 'DirectionsBike'
  | 'DirectionsBoat'
  | 'DirectionsCar'
  | 'Email'
  | 'EmojiObjects'
  | 'ExpandLess'
  | 'ExpandMore'
  | 'ExternalLink'
  | 'Facebook'
  | 'Favourite'
  | 'FingerPrint'
  | 'FollowTheSign'
  | 'GridLarge'
  | 'GridSmall'
  | 'Hamburger'
  | 'HelpOutline'
  | 'HidePassword'
  | 'Home'
  | 'Instagram'
  | 'LocalFlorist'
  | 'Lock'
  | 'Loyalty'
  | 'maestro'
  | 'Magazine'
  | 'mastercard'
  | 'MoreHorizontal'
  | 'MoreVertical'
  | 'Number1'
  | 'Number2'
  | 'Pencil'
  | 'Pinterest'
  | 'Plus'
  | 'RemoveRedEye'
  | 'RichTextBold'
  | 'RichTextBulletPoint'
  | 'RichTextItalic'
  | 'RichTextParagraph'
  | 'RichTextRedo'
  | 'RichTextUndo'
  | 'Search'
  | 'SeriesOfTubes'
  | 'Share'
  | 'ShoppingBasket'
  | 'ShowPassword'
  | 'SimpleMagazine'
  | 'SlimArrowDown'
  | 'SlimArrowUp'
  | 'Square'
  | 'StoreFront'
  | 'StoreMallDirectory'
  | 'Trash'
  | 'Upload'
  | 'ViewComfy'
  | 'visa'
  | 'WhatsHot'
  | 'EyeIcon';

// things that the user might do while not authenticated which need authentication
export type PendingAuthenticatedAction =
  | PendingAuthenticatedActions.accountmanagement
  | PendingAuthenticatedActions.buy
  | PendingAuthenticatedActions.bylist
  | PendingAuthenticatedActions.mylists
  | PendingAuthenticatedActions.myorderhistory
  | PendingAuthenticatedActions.mytrips
  | PendingAuthenticatedActions.shareproduct
  | PendingAuthenticatedActions.smartBrowser
  | PendingAuthenticatedActions.tagmenu;

export enum PendingAuthenticatedActions {
  mytrips = 'mytrips',
  tagmenu = 'tagmenu',
  bylist = 'bylist',
  mylists = 'mylists',
  myorderhistory = 'myorderhistory',
  shareproduct = 'shareproduct',
  accountmanagement = 'accountmanagement',
  buy = 'buy',
  smartBrowser = 'smartBrowser',
}

export const PendingAuthenticationActionBlurbFallback: string =
  'Welcome back to Toscan!';

export enum ScreenSize {
  thinmobile = 'thinmobile',
  mobile = 'mobile',
  tabletPortrait = 'tabletPortrait',
  tabletLandscape = 'tabletLandscape',
  desktop = 'desktop',
}

export enum ViewModes {
  bypage = 'bypage',
}

type INavigationLeafStyling = {
  marginTop?: number;
  marginBottom?: number;
};
export type INavigationLeaf = {
  id: string;
  name: string;
  action: () => void;
  disabled?: boolean;
  secondary?: boolean;
  styling?: INavigationLeafStyling;
};
// @ts-expect-error
export const PendingAuthenticationActionBlurb: Record<
  PendingAuthenticatedAction,
  string
> = {
  [PendingAuthenticatedActions.mytrips]:
    'You need to be signed in to retrace your steps and review the things you have discovered.',
  [PendingAuthenticatedActions.tagmenu]:
    'You need to be signed in to organise your discoveries with lists.',
  [PendingAuthenticatedActions.bylist]:
    PendingAuthenticationActionBlurbFallback,
  [PendingAuthenticatedActions.mylists]:
    'You need to be signed in to organise your discoveries with lists.',
  [PendingAuthenticatedActions.myorderhistory]:
    'You need to be signed in to view and manage your order history.',
  [PendingAuthenticatedActions.shareproduct]:
    'You need to be signed in to share your discoveries by email.',
  [PendingAuthenticatedActions.accountmanagement]:
    PendingAuthenticationActionBlurbFallback,
  [PendingAuthenticatedActions.buy]: PendingAuthenticationActionBlurbFallback,
};

export const enum ProductPanelMarkers {
  ProductDescription = 'ProductDescription',
  BuyFlow = 'BuyFlow',
  SharedComponent = 'SharedComponent',
  CollectDeliveryAddress = 'CollectDeliveryAddress',
  SelectedDeliveryAddress = 'SelectedDeliveryAddress',
  CollectPaymentMethod = 'CollectPaymentMethod',
}

export type ZoomSpan = 'span0' | 'span1' | 'span2' | 'span3';
